var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "award 1",
    clipPath: "url(#clip0_2737_1486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.8524 10.1883L18.463 8.95946C19.8076 8.53342 20.7109 7.29859 20.7109 5.88672V2.66406H18.7773V2.01953C18.7773 1.66358 19.0659 1.375 19.4219 1.375H22V5.88672C22 6.86439 21.6923 7.7947 21.1103 8.57716C20.54 9.34386 19.7593 9.90099 18.8524 10.1883Z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.1475 10.1883C2.24069 9.90095 1.45995 9.34386 0.889668 8.57716C0.307656 7.7947 0 6.86434 0 5.88672V1.375H2.57812C2.93408 1.375 3.22266 1.66358 3.22266 2.01953V2.66406H1.28906V5.88672C1.28906 7.29859 2.19239 8.53342 3.53693 8.9595L3.1475 10.1883Z",
    fill: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.1562 1.375L15.5117 8.46484V16.4165L17.4405 14.5278L19.3789 16.4662V1.375H16.1562Z",
    fill: "#FF641A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.84375 1.375H2.62109V16.4165L4.54992 14.5278L6.48828 16.4662V8.46484L5.84375 1.375Z",
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.8008 8.46484V0H5.19922V8.46484C5.19922 10.9433 6.76586 13.1252 9.06641 13.9356V18.1328H7.28492C6.13508 18.1328 5.19922 19.0687 5.19922 20.2185V22H16.8008V20.2185C16.8008 19.0687 15.8649 18.1328 14.7151 18.1328H12.9336V13.9356C15.2341 13.1252 16.8008 10.9429 16.8008 8.46484Z",
    fill: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.9336 13.9356V18.1328H14.7151C15.8649 18.1328 16.8008 19.0687 16.8008 20.2185V22H11V0H16.8008V8.46484C16.8008 10.9429 15.2341 13.1252 12.9336 13.9356Z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.9871 5.08449L12.2203 4.69218L11 2.2782L9.7797 4.69218L7.01294 5.08449L9.01614 6.99101L8.54735 9.66023L11 8.40125L13.4527 9.66023L12.9839 6.99101L14.9871 5.08449Z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M12.9839 6.99101L13.4527 9.66023L11 8.40125V2.2782L12.2203 4.69218L14.9871 5.08449L12.9839 6.99101Z",
    fill: "#FF9100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2737_1486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.b12b82412cff39533478d50684e4411b.svg";
export { ForwardRef as ReactComponent };